import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { TAB_4B_TRIGGER_HELP_BLOCK, TAB_4B_UPDATE_INVOICE } from "actions";
import { Input } from "components";

const InfoIconInner = styled.div`
  background: ${props => props.bg};
  &:hover {
    filter: brightness(125%);
  }
`;

const YearItem = props => {
  const { updateInvoice, label, totalSales, totalBadDebts, largestBadDebt, triggerHelpBlock, domain } = props;
  return (
    <div className="invoice_slide" data-merge="1">
      <div className="inner_slide">
        <div className="invoice_slide--title">
          <h4>{label}</h4>
          <div onClick={triggerHelpBlock} className="info_icon">
            <InfoIconInner bg={domain.BaseColour} onClick={triggerHelpBlock} className="info_icon_inner">
              ?
            </InfoIconInner>
          </div>
        </div>
        <div className="invoice_slide--caption">
          <div>
            <label>{domain.Strings.tab4BCarouselSalesLabel}</label>
            <Input prefix={props.domain.Currency} addCommas onChange={updateInvoice} type="number" name="totalSales" value={totalSales} placeholder={domain.Strings.tab4BCarouselSalesPlaceholder} />
          </div>
          <div>
            <label>{domain.Strings.tab4BCarouselBadDebtsLabel}</label>
            <Input prefix={props.domain.Currency} addCommas onChange={updateInvoice} type="number" name="totalBadDebts" value={totalBadDebts} placeholder={domain.Strings.tab4BCarouselBadDebtsPlaceholder} />
          </div>
          <div>
            <label>{domain.Strings.tab4BCarouselLargestDebtLabel}</label>
            <Input prefix={props.domain.Currency} addCommas onChange={updateInvoice} type="number" name="largestBadDebt" value={largestBadDebt} placeholder={domain.Strings.tab4BCarouselLargestDebtPlaceholder} />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  const { yearValue } = ownProps;
  return {
    ...state.app.years.find(year => year.value === yearValue),
    domain: state.app.domain
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const { yearValue } = ownProps;
  return {
    triggerHelpBlock: () => dispatch({ type: TAB_4B_TRIGGER_HELP_BLOCK }),
    updateInvoice: data => dispatch({ type: TAB_4B_UPDATE_INVOICE, yearValue, ...data })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(YearItem);
